import React from 'react';

interface Phase {
  id: string;
  label: string;
  name: string;
  active: boolean;
}

const phases: Phase[] = [
  {
    id: 'A',
    label: 'A',
    name: 'Problem Discovery & Quantification',
    active: false
  },
  {
    id: 'B',
    label: 'B',
    name: 'Solution Design & Stakeholder Alignment',
    active: false
  },
  {
    id: 'C',
    label: 'C',
    name: 'Implementation & Rollout',
    active: false
  },
  {
    id: 'D',
    label: 'D',
    name: 'Adoption Enforcement & Change Management',
    active: false
  },
  {
    id: 'E',
    label: 'E',
    name: 'Post-Implementation Adoption Monitor',
    active: true
  }
];

interface TekkriSidebarProps {
  onPhaseClick?: (phaseId: string) => void;
}

/**
 * TekkriSidebar Component
 * Sidebar navigation showing project phases
 */
const TekkriSidebar: React.FC<TekkriSidebarProps> = ({ onPhaseClick }) => {
  const handlePhaseClick = (phase: Phase) => {
    if (!phase.active && onPhaseClick) {
      onPhaseClick(phase.id);
    }
  };

  return (
    <aside className="tekkr-sidebar">
      <div className="tekkr-sidebar-title">Project Phases</div>
      {phases.map((phase) => (
        <div
          key={phase.id}
          className={`tekkr-sidebar-item ${phase.active ? 'active' : ''}`}
          onClick={() => handlePhaseClick(phase)}
        >
          <span className="tekkr-sidebar-phase-label">{phase.label}.</span>
          <span>{phase.name}</span>
        </div>
      ))}
    </aside>
  );
};

export default TekkriSidebar;

